export type DashboardDetailsType = {
  list: Array<BlogData>;
  loading: boolean;
};

export const initialState: DashboardDetailsType = {
  list: [],
  loading: false,
};
